import { createContext } from 'react';

interface IContext {
  selectedValues: string[];
  onSelect: (value: string) => void;
}

export const SelectorListContext = createContext<IContext | null>(null);
